import * as React from "react";
import classnames from "classnames";
import { useSelector } from "@grandvisionhq/state";
import { sortPrescriptionParameters, isDefined } from "@grandvisionhq/utils";
import { getFormValidationParameters } from "../../../../../../../../state/configurations/state/configurations/selectors.js";
import { usePrescriptionFormLayout } from "../../../../../../context/steps/PrescriptionFormStep/context/PrescriptionFormLayoutContext.js";
import { PrescriptionFormColumnHeading } from "../../../../../PrescriptionFormColumnHeading/steps/PrescriptionFormStep/components/PrescriptionFormColumnHeading/PrescriptionFormColumnHeading.js";
import { PrescriptionFormInputContainer } from "../../../../../PrescriptionFormInput/steps/PrescriptionFormStep/components/PrescriptionFormInput/PrescriptionFormInputContainer.js";
/* empty css                            */
const PrescriptionFormColumn = ({
  id,
  className,
  hideSelectLabels,
  columnTitle,
  errorMessageId,
  parameters,
  selectedValues,
  validations,
  showValidation,
  onAttributeChange,
  showHeading = true,
  side
}) => {
  const paramSortingOrder = sortPrescriptionParameters(parameters.map((p) => p.name));
  const { layout } = usePrescriptionFormLayout();
  const sortedParams = [...parameters].sort(function(a, b) {
    return paramSortingOrder.indexOf(a.name) - paramSortingOrder.indexOf(b.name);
  });
  const validationParameters = useSelector(getFormValidationParameters);
  const isParameterRequired = React.useCallback(
    (param) => {
      if (!isDefined(validationParameters)) {
        return false;
      }
      const validationFormParam = validationParameters.find(
        (sourceParam) => sourceParam.name === param.name
      );
      return !validationFormParam?.isOptional;
    },
    [validationParameters]
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      "aria-label": columnTitle,
      className: classnames(className, "prescription-form-column", {
        "prescription-form-column--hide-labels": hideSelectLabels,
        "prescription-form-column--is-single-column": layout === "singleColumn"
      }),
      role: "group"
    },
    showHeading && /* @__PURE__ */ React.createElement(
      PrescriptionFormColumnHeading,
      {
        id,
        className: classnames("prescription-form-column__heading", {
          "prescription-form-column__heading--is-single-column": layout === "singleColumn"
        })
      },
      columnTitle
    ),
    sortedParams.map((parameter, index, array) => /* @__PURE__ */ React.createElement(
      PrescriptionFormInputContainer,
      {
        side,
        key: parameter.name,
        parentId: id,
        parameter,
        onAttributeChange,
        isFirstItem: index === 0,
        isLastItem: index === array.length - 1,
        selectedValues,
        validations,
        showValidation,
        hideLabels: hideSelectLabels,
        errorMessageId,
        required: isParameterRequired(parameter)
      }
    ))
  );
};
const PrescriptionFormColumn$1 = React.memo(PrescriptionFormColumn);
export {
  PrescriptionFormColumn$1 as default
};
//# sourceMappingURL=PrescriptionFormColumn.js.map
